import { Action } from "redux";
import { AgentGroup } from "../../shared/model/AgentGroup";
import { HashMap} from "../../shared/model/HashMap";
import { State } from "../model/State";

import * as FetchActions from "../actions/FetchActions";
import * as ProcessListActions from "../actions/ProcessListActions";

export function agentGroups(state: HashMap<AgentGroup> = {Default: {name: "Default", displayName: "Development", environment: "Default", environmentDisplayName: "Development", agents: [], allowRunningTestProcesses: true}}, action: Action): HashMap<AgentGroup> {
    switch (action.type) {
        case FetchActions.RECEIVE_AGENT_GROUPS:
            const receiveAction = action as FetchActions.ReceiveAgentGroupsAction;
            return receiveAction.agentGroups;
        default:
            return state;
    }
}

export function currentAgentGroupName(state: string = "", action: Action): string {
    switch (action.type) {
        case ProcessListActions.CHANGE_AGENT_GROUP:
            const changeAction = action as ProcessListActions.ChangeAgentGroupAction;
            return changeAction.agentGroupName;
        default:
            return state;
    }
}
